import { httpClient } from '@bcba/client-auth';
import {
  DigitalDossierGeneralInformationSerializer,
  DigitalDossierBankingInformationSerializer,
  DigitalDossierRepresentantInformationSerializer,
  ExplorerDigitalDossierTaxInformationSerializer,
  ExplorerDigitalDossierFormsAndDocsInformationSerializer,
} from '@bcba/serializers';
import { basePath } from '.';

export const getGeneralInformation = async () => {
  const { data } =
    await httpClient.get<DigitalDossierGeneralInformationSerializer>(basePath);
  return data;
};

export const getTaxInformation = async () => {
  const { data } =
    await httpClient.get<ExplorerDigitalDossierTaxInformationSerializer>(
      `${basePath}/tax-information`,
    );
  return data;
};

export const getFormAndDocsInformation = async () => {
  const { data } =
    await httpClient.get<ExplorerDigitalDossierFormsAndDocsInformationSerializer>(
      `${basePath}/company-forms-and-docs`,
    );
  return data;
};

export const getBankingInformation = async () => {
  const { data } = await httpClient.get<
    DigitalDossierBankingInformationSerializer[]
  >(`${basePath}/banking-information`);
  return data;
};

export const getRepresentantInformation = async () => {
  const { data } = await httpClient.get<
    DigitalDossierRepresentantInformationSerializer[]
  >(`${basePath}/representant-information`);
  return data;
};
